// All the api requests are here....
import { apiSlice, baseUrl } from "./apiSlice";

export const httpApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTrendngData: builder.query({
      query: (media) => ({
        url: `${baseUrl}api/v1/trending/today/${media}`,
      }),
      keepUnusedDataFor: 300,
      providesTags: ["Trending"],
    }),

    getDataByGenreId: builder.query({
      query: ({ media, genreId, pageNumber }) => ({
        url: `${baseUrl}api/v1/discover/${media}/${genreId}/${pageNumber}`,
      }),
      keepUnusedDataFor: 300,
      providesTags: ["Discover"],
    }),

    getMovieGenreList: builder.query({
      query: () => ({
        url: `${baseUrl}api/v1/movie/genre/list`,
      }),
      keepUnusedDataFor: 300,
      providesTags: ["GenreList"],
    }),

    getSeriesGenreList: builder.query({
      query: () => ({
        url: `${baseUrl}api/v1/series/genre/list`,
      }),
      keepUnusedDataFor: 300,
      providesTags: ["GenreList"],
    }),

    getMovieDetails: builder.query({
      query: (movieId) => ({
        url: `${baseUrl}api/v1/movie/details/${movieId}`,
      }),
      keepUnusedDataFor: 300,
      providesTags: ["Movie"],
    }),

    getFreeMovies: builder.query({
      query: () => ({
        url: `${baseUrl}api/v1/free/movies`,
      }),
      keepUnusedDataFor: 300,
      providesTags: ["Movie"],
    }),

    getSeriesDetails: builder.query({
      query: (seriesId) => ({
        url: `${baseUrl}api/v1/series/details/${seriesId}`,
      }),
      keepUnusedDataFor: 300,
      providesTags: ["Series"],
    }),

    getFreeSeries: builder.query({
      query: () => ({
        url: `${baseUrl}api/v1/free/series`,
      }),
      keepUnusedDataFor: 300,
      providesTags: ["Series"],
    }),

    getSeriesSeasonDetails: builder.query({
      query: ({ seriesId, season }) => ({
        url: `${baseUrl}api/v1/series/${seriesId}/${season}`,
      }),
      keepUnusedDataFor: 300,
      providesTags: ["Series"],
    }),

    getWatchProviders: builder.mutation({
      query: (body) => ({
        url: `${baseUrl}api/v1/watch/providers`,
        method: "POST",
        body,
      }),
    }),

    signup: builder.mutation({
      query: (body) => ({
        url: `${baseUrl}api/v1/signup/web`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["User"],
    }),

    login: builder.mutation({
      query: (body) => ({
        url: `${baseUrl}api/v1/login`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["User"],
    }),

    postReview: builder.mutation({
      query: ({ body, token }) => ({
        url: `${baseUrl}api/v1/protected/post/review`,
        method: "POST",
        body,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
      invalidatesTags: ["Reviews"],
    }),

    getReviews: builder.query({
      query: ({ media_id, media_type }) => ({
        url: `${baseUrl}api/v1/get/reviews/${media_id}/${media_type}`,
      }),
      keepUnusedDataFor: 300,
      providesTags: ["Reviews"],
    }),

    getSearchResults: builder.mutation({
      query: ({ body }) => ({
        url: `${baseUrl}api/v1/search`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Search"],
    }),

    getTopResults: builder.query({
      query: ({ page }) => ({
        url: `${baseUrl}api/v1/top/searches/${page}`,
      }),
      keepUnusedDataFor: 300,
      providesTags: ["Search"],
    }),

    uploadPost: builder.mutation({
      query: ({ body, token }) => ({
        url: `${baseUrl}api/v1/protected/upload/post`,
        method: "POST",
        body,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
      invalidatesTags: ["Community"],
    }),

    fetchPosts: builder.mutation({
      query: ({ body }) => ({
        url: `${baseUrl}api/v1/fetch/posts/web`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Community"],
    }),

    getShortz: builder.query({
      query: () => ({
        url: `${baseUrl}api/v1/fetch/shortz`,
      }),
      keepUnusedDataFor: 300,
      providesTags: ["Shortz"],
    }),

    createWatchlist: builder.mutation({
      query: ({ body, token }) => ({
        url: `${baseUrl}api/v1/protected/create/watchlist`,
        method: "POST",
        body,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
      invalidatesTags: ["Watchlist"],
    }),

    getUserWatchlist: builder.query({
      query: ({ user_id, token }) => ({
        url: `${baseUrl}api/v1/protected/get/user/watchlist/${user_id}`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
      keepUnusedDataFor: 300,
      providesTags: ["Watchlist"],
    }),

    addItemInWatchlist: builder.mutation({
      query: ({ body, token }) => ({
        url: `${baseUrl}api/v1/protected/add/item-in-watchlist`,
        method: "POST",
        body,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
      invalidatesTags: ["Watchlist"],
    }),

    addMultipleItemsInWatchlist: builder.mutation({
      query: ({ body, token }) => ({
        url: `${baseUrl}api/v1/protected/add/multiple-items-in-watchlist`,
        method: "POST",
        body,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
      invalidatesTags: ["Watchlist"],
    }),

    removeItemFromWatchlist: builder.mutation({
      query: ({ body, token }) => ({
        url: `${baseUrl}api/v1/protected/remove/item-from-watchlist`,
        method: "POST",
        body,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
      invalidatesTags: ["Watchlist"],
    }),

    editWatchlist: builder.mutation({
      query: ({ body, token }) => ({
        url: `${baseUrl}api/v1/protected/edit/watchlist-name`,
        method: "POST",
        body,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
      invalidatesTags: ["Watchlist"],
    }),

    deleteWatchlist: builder.mutation({
      query: ({ body, token }) => ({
        url: `${baseUrl}api/v1/protected/delete/watchlist`,
        method: "POST",
        body,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
      invalidatesTags: ["Watchlist"],
    }),

    getUserReviews: builder.mutation({
      query: ({ body, token }) => ({
        url: `${baseUrl}api/v1/protected/get/user-reviews`,
        method: "POST",
        body,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
      invalidatesTags: ["Reviews"],
    }),

    editUserReview: builder.mutation({
      query: ({ body, token }) => ({
        url: `${baseUrl}api/v1/protected/edit/user-review`,
        method: "POST",
        body,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
      invalidatesTags: ["Reviews"],
    }),

    deleteUserReview: builder.mutation({
      query: ({ body, token }) => ({
        url: `${baseUrl}api/v1/protected/delete/user-review`,
        method: "POST",
        body,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
      invalidatesTags: ["Reviews"],
    }),
    getUserProfileDetails: builder.mutation({
      query: ({ body, token }) => ({
        url: `${baseUrl}api/v1/protected/get/user-profile`,
        method: "POST",
        body,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
      invalidatesTags: ["Reviews"],
    }),
    getComments: builder.mutation({
      query: ({ body }) => ({
        url: `${baseUrl}api/v1/fetch/comments`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Community"],
    }),
    postComment: builder.mutation({
      query: ({ body, token }) => ({
        url: `${baseUrl}api/v1/protected/post/comment`,
        method: "POST",
        body,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
      invalidatesTags: ["Community"],
    }),
    getUserLikedPosts: builder.mutation({
      query: ({ body, token }) => ({
        url: `${baseUrl}api/v1/protected/user-liked-posts`,
        method: "POST",
        body,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
      invalidatesTags: ["Community"],
    }),
    likePost: builder.mutation({
      query: ({ body, token }) => ({
        url: `${baseUrl}api/v1/protected/like-post`,
        method: "POST",
        body,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
      invalidatesTags: ["Community"],
    }),
    getUserPosts: builder.mutation({
      query: ({ body, token }) => ({
        url: `${baseUrl}api/v1/protected/user-posts`,
        method: "POST",
        body,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
      invalidatesTags: ["Community"],
    }),
    deletePost: builder.mutation({
      query: ({ body, token }) => ({
        url: `${baseUrl}api/v1/protected/delete-post`,
        method: "POST",
        body,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
      invalidatesTags: ["Community"],
    }),
    fetchPersonDetails: builder.mutation({
      query: ({ body }) => ({
        url: `${baseUrl}api/v1/fetch-person-details`,
        method: "POST",
        body,
      }),
    }),
    deleteAccount: builder.mutation({
      query: (body) => ({
        url: `${baseUrl}api/v1/delete-account`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["User"],
    }),
  }),
});

export const {
  useGetTrendngDataQuery,
  useGetDataByGenreIdQuery,
  useGetMovieGenreListQuery,
  useGetSeriesGenreListQuery,
  useGetMovieDetailsQuery,
  useGetFreeMoviesQuery,
  useGetSeriesDetailsQuery,
  useGetFreeSeriesQuery,
  useGetSeriesSeasonDetailsQuery,
  useGetWatchProvidersMutation,
  useSignupMutation,
  useLoginMutation,
  usePostReviewMutation,
  useGetReviewsQuery,
  useGetTopResultsQuery,
  useGetSearchResultsMutation,
  useUploadPostMutation,
  useFetchPostsMutation,
  useGetShortzQuery,
  useCreateWatchlistMutation,
  useGetUserWatchlistQuery,
  useAddItemInWatchlistMutation,
  useAddMultipleItemsInWatchlistMutation,
  useRemoveItemFromWatchlistMutation,
  useEditWatchlistMutation,
  useDeleteWatchlistMutation,
  useGetUserReviewsMutation,
  useEditUserReviewMutation,
  useDeleteUserReviewMutation,
  useGetUserProfileDetailsMutation,
  useGetCommentsMutation,
  usePostCommentMutation,
  useGetUserLikedPostsMutation,
  useLikePostMutation,
  useGetUserPostsMutation,
  useDeletePostMutation,
  useFetchPersonDetailsMutation,
  useDeleteAccountMutation,
} = httpApiSlice;
// export const { useGetProductsQuery , useCreateProductMutation } = httpApiSlice;
// export const { useGetTopProductsQuery,useCreateReviewMutation,useDeleteProductMutation,useUploadProductImageMutation,useGetProductDetailsQuery , useUpdateProductMutation } = httpApiSlice;
